<template>
  <div class="animate_animated animate__slideInRight">
    <div class="fixed w-full top-0 left-0 z-20">
      <div class="bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
        <div class="h-1 bg-gradient-to-r from-amber-500 to-amber-200"></div>
        <div class="flex items-center px-4 py-4">
          <div class="w-1/2">
              <div class="flex items-center w-full">
                <a @click="$router.go(-1)"><img src="@/assets/back-arrow.svg" alt=""></a>
                <span class="text-base text-content font-medium ml-4">Enquiry History</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="pt-20 bg-gray-50 p-5 min-h-screen">
      <!-- Card-List -->
      <div class="bg-gray-50" v-for="(eh, key) in enquiryHistory" :key="key">
        <div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">
          <div class="grid gap-3 grid-cols-2">
            <div>
              <span class="block text-xs text-slate-500 mb-1">Status From</span>
              <span class="block text-sm text-slate-600">{{ eh.status_from }}</span>
            </div>
            <div>
              <span class="block text-xs text-slate-500 mb-1">Status To</span>
              <span class="block text-sm text-slate-600">{{ eh.status_to }}</span>
            </div>
            <div>
              <span class="block text-xs text-slate-500 mb-1">Assign From</span>
              <span class="block text-sm text-slate-600">{{ eh.assigned_from }}</span>
            </div>
            <div>
              <span class="block text-xs text-slate-500 mb-1">Assign to</span>
              <span class="block text-sm text-slate-600">{{ eh.assigned_to }}</span>
            </div>
            <div>
              <span class="block text-xs text-slate-500 mb-1">By</span>
              <span class="block text-sm text-slate-600">{{ eh.by }}</span>
            </div>
            <div class="col-span-2">
              <span class="block text-xs text-slate-500 mb-1">Comment From</span>
                      <ReadMore more-str="read more" :text="eh.comment_from" v-if="eh.comment_from" less-str="read less" :max-chars="50">
        </ReadMore>
            </div>
            <div class="col-span-2">
              <span class="block text-xs text-slate-500 mb-1">Comment To</span>
                      <ReadMore more-str="read more" :text="eh.comment_to"
          v-if="eh.comment_to" less-str="read less" :max-chars="50"></ReadMore>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  data() {
    return {
      enquiryHistory: [],
    }
  },
  watch: {
    $route(to, from) {
      this.loadHistory();
    }
  },
  created() {
    this.loadHistory()
  },
  methods: {
    loadHistory() {
      let data = this.$axios.get(`/mobile_crm/leads/${this.$route.params.uuid}/histories`)
        .then(res => {
          this.enquiryHistory = res.data.audits;
        })
        .catch(err => console.log(err));
    },
  }
}
</script>
